export default "/assets/images/two-size-mila.webp?ea37bba62fa9a3e645309d473aab20dc";